export default __webpack_public_path__ + "static/franklin-templeton-2cf88626fa52f1f9477ba73d776c01a8.png";